import { render } from "./ListView.vue?vue&type=template&id=216f4601"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__